export const removeWhitespace = string => (
  string.replace(' ', '')
);
